import React from 'react'
import './Features.css'

function Features() {
  const features = [
    {
      icon: '🌙',
      title: 'Autonomous Development',
      description: 'Set your requirements and let AI work overnight. Wake up to completed features, bug fixes, and tested code.'
    },
    {
      icon: '🔄',
      title: 'Multi-IDE Support',
      description: 'Seamlessly integrates with Cursor, VS Code, and Windsurf. Use your favorite development environment.'
    },
    {
      icon: '🎯',
      title: 'Smart Requirements',
      description: 'Simple markdown-based requirements tracking. Vibe Coding Machine understands your goals and implements them intelligently.'
    },
    {
      icon: '🤖',
      title: 'Continuous Integration',
      description: 'Automated workflows that work seamlessly across different AI assistants and development environments.'
    },
    {
      icon: '📊',
      title: 'Progress Tracking',
      description: 'Real-time monitoring of development progress. Know exactly what got done while you were away.'
    },
    {
      icon: '🔒',
      title: 'Safe & Secure',
      description: 'Your code stays local. No cloud uploads. Complete control over your development environment.'
    }
  ]

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="features-header">
          <h2 className="features-title">
            Everything you need for<br />
            <span className="gradient-text">autonomous development</span>
          </h2>
          <p className="features-subtitle">
            Vibe Coding Machine provides a complete solution for AI-powered development workflows
          </p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
